import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Flex } from './Flex';
import { Tooltip as AntdTooltip } from 'antd';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const TooltipTrigger = styled.div`
    ${({ visible }) => visible && css`
        &:hover + div {
            visibility: visible;
            animation: ${fadeIn} 1s;
        }

        &:active {
            // pointer-events: none;
        }`
    }
`;

const TooltipWrapper = styled(Flex).attrs({
    position: 'absolute'
})`
    top: ${({top}) => top};
    left: ${({left}) => left};
    bottom: ${({bottom}) => bottom};
    right: ${({right}) => right};
    visibility: hidden;
    z-index: 101;
`;

const TooltipText = styled(Flex).attrs({
    position: 'relative',
    height: '36px',
    align: 'center',
    padding: { left: '16px', right: '16px' },
    background: 'rgba(40, 67, 111, 0.9)',
    whiteSpace: 'nowrap'
})`
    border-radius: 8px;

    font-weight: 600;
    font-size: 16px;
    line-height: 22px;

    color: #FFFFFF;
    text-transform: capitalize;

    &::after {
        content: "";
        position: absolute;
        bottom: ${({placement}) => placement === "top" && "-6px"};
        left: ${({placement}) => placement === "left" && "-6px"};
        border-width: 3px;
        border-style: solid;
        border-color: ${({placement}) => placement === "top"
            ? "rgba(40, 67, 111, 0.9) transparent transparent transparent"
            : "transparent rgba(40, 67, 111, 0.9) transparent transparent"};
}
`;

const Tooltip = ({ visible, text, children, ...props }) => {
    return(
        <>
            <TooltipTrigger visible={visible}>
                {children}
            </TooltipTrigger>
            <TooltipWrapper
                bottom={props.bottom ? props.bottom : props.placement === "top" ? "110%" : undefined}
                {...props}
            >
                <TooltipText placement={props.placement || "left"}>
                    {text}
                </TooltipText>
            </TooltipWrapper>
        </>
    );
};

const StyledAntdTooltip = styled(AntdTooltip).attrs({
    color: 'rgba(40, 67, 110, 0.85)',
    overlayInnerStyle: { borderRadius: "8px", padding: "16px" }
})``;

const FormTooltip = ({ text, children }) => (
    <StyledAntdTooltip title={text}>
        {children}
    </StyledAntdTooltip>
);

const StyledAntdNavTooltip = styled(AntdTooltip).attrs({
    color: 'rgba(40, 67, 111, 0.9)',
    placement: "right",
    overlayClassName: "sp-navigation-tooltip",
    overlayInnerStyle: {
        height: "36px",
        borderRadius: "8px",
        paddingLeft: "16px",
        paddingRight: "16px",
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        textTransform: "capitalize"
    }
})``;

const NavigationTooltip = ({ text, children, ...props }) => (
    <StyledAntdNavTooltip title={text} {...props}>
        {children}
    </StyledAntdNavTooltip>
);

export { Tooltip };
export { FormTooltip };
export { NavigationTooltip };